import React from 'react';

const EvidenceBanner = () => {
  return (
    <section
      className="h-[55vh] sm:h-[70vh] md:h-[90vh] lg:h-[92vh] bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: "url('/images/better-deta.webp')"
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
      />
      
      {/* Banner Content */}
      <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="text-left text-white max-w-4xl ml-0 sm:ml-8 md:ml-24 lg:ml-48 xl:ml-72">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            Better data for better<br />
            <span style={{ color: '#db0058' }}>business outcomes.</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 leading-relaxed max-w-xs sm:max-w-none">
            We have a wealth of experience in harnessing our consumer data and using it to deliver tangible business outcomes. The evidence speaks volumes...
          </p>
        </div>
      </div>
    </section>
  );
};

export default EvidenceBanner;